import { withCommonMoveSetup } from './moveDecorator.js';

/**
 * Custom implementation for Water Sport.
 * Field effect: halves the base power of Fire-type moves for all Pokémon until
 * the user switches out or faints.
 */
export default class WaterSport {
    static customMoveLogic(battleStateMachine, move, attacker, defender) {
        battleStateMachine.addFieldEffect('water_sport', attacker);
        battleStateMachine.context.actions.push(
            battleStateMachine.ag.readText(`Fire's power was weakened!`, { delay: 50 })
        );
    }

    static setUpBattleActions = withCommonMoveSetup(WaterSport.customMoveLogic);
}
